import React, { CSSProperties, ReactElement } from "react";
import { Dimmer, Icon, Loader } from "semantic-ui-react";
import { makeStyles } from "@mui/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { CardActionArea } from "@mui/material";

type CardOptionItemProps = {
  className?: string;
  img?: string;
  icon?: ReactElement;
  label: string;
  circular?: boolean;
  style?: CSSProperties;
  imgStyle?: CSSProperties;
  labelStyle?: CSSProperties;
  contentStyle?: CSSProperties;
  rightIcon?: boolean;
  loading?: boolean;
  onClick?: () => void;
};

const useStyles = makeStyles(() => ({
  card: {
    "&.MuiPaper-root": {
      borderRadius: "12px",
      boxShadow: "0px 0px 8px 0px rgba(0, 0, 0, 0.15)",
      marginBottom: "1.35rem",
      fontSize: "15px",
      "& .MuiTouchRipple-ripple": {
        color: "var(--primary-theme-color)",
      },
    },
  },
  rightIcon: {
    "&.icon": {
      margin: "-2px -4px 0 auto",
      color: "var(--primary-theme-color)",
      fontSize: "1.25em",
    },
  },
  serviceIcon: {
    marginRight: "1rem",
    width: "35px",
    height: "35px",
    objectFit: "cover",
  },
}));

const CardOptionItem = (props: CardOptionItemProps) => {
  const classes = useStyles();

  return (
    <Card className={`${classes.card} ${props.className}`} style={props.style}>
      <CardActionArea onClick={props.onClick}>
        <CardContent
          style={{
            display: "flex",
            alignItems: "center",
            ...props.contentStyle,
          }}
        >
          {props.img && (
            <img
              src={props.img}
              alt=""
              className={classes.serviceIcon}
              style={{
                borderRadius: props.circular ? "50%" : "",
                ...props.imgStyle,
              }}
            />
          )}
          {props.icon}
          <label style={props.labelStyle}>{props.label}</label>
          {props.rightIcon !== false && (
            <>
              {props.loading ? (
                <div
                  style={{
                    position: "relative",
                    margin: "-30px 22px 0px auto",
                  }}
                >
                  <Dimmer active={true} inverted={true}>
                    <Loader size="small" inline style={{ transform: "scale(0.75)" }} />
                  </Dimmer>
                </div>
              ) : (
                <Icon name="chevron right" className={classes.rightIcon} />
              )}
            </>
          )}
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default CardOptionItem;
